import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";
import OutlinedInput from "@mui/material/OutlinedInput";
import { forwardRef, useId } from "react";

const CustomInput = (
// CustomInputWith_forwardRef 

  {
    error = false,
    label,
    value,
    onChange,
    helperText = "",
    placeholder = "",
    type,
    startAdornment,
    endAdornment,
    className="",
    defaultValue,
    onClick,
    disabled = false,
    onKeyPress,
    onPaste,
    onKeyDown,
  
  }) => {
  const id = useId();

  return (

    <FormControl error={error} fullWidth>
      <label>{label}</label>
      <OutlinedInput
        error={error}
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        startAdornment={startAdornment}
        endAdornment={endAdornment}
        className={className}
        defaultValue={defaultValue} 
        onClick={onClick} 
        disabled={disabled} 
        onKeyPress={onKeyPress}
        onPaste={onPaste}
        onKeyDown={onKeyDown}
      />
      {error && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

// CustomInputWith_forwardRef.displayName = "CustomInput";

// const CustomInput = forwardRef(CustomInputWith_forwardRef);

export default CustomInput;
